<nav id="breadcrumb">
  <ol class="breadcrumb">
    @for (crumb of breadcrumbs | async; track crumb.label; let isLast = $last) {
      <li class="breadcrumb-item" [class.active]="isLast">
        @if (isLast) {
          <layout-breadcrumb-item [item]="crumb" data-cy="BreadcrumbItem"/>
        }
        @if (!isLast) {
          <a [routerLink]="[ crumb.url ]" data-cy="BreadcrumbItem"><layout-breadcrumb-item [item]="crumb"/></a>
        }
      </li>
    }
  </ol>
</nav>
